module.exports = __webpack_public_path__ + "img/gender-plug-icon.3222de45.svg";